import React from "react";
import Banner from "../components/Banner";
import AboutSection from "../components/HomePage/AboutSection";
import CounterSection from "../components/CounterSection";
import ServicesSection from "../components/HomePage/ServicesSection";
import PricingSection from "../components/HomePage/PricingSection";
import TestimonialSection from "../components/HomePage/TestimonialSection";
import ServicesFetureSection from "../components/HomePage/ServicesFetureSection";
import VideoSection from "../components/HomePage/VideoSection";
import ContactUs from "./ContactUs";
import WorkSection from "../components/HomePage/WorkSection";
import './Page.css';
import FAQSection from "../components/HomePage/FAQSection";




const Page = () => {


  return (
    <>
      <Banner></Banner>
      <ServicesSection></ServicesSection>
      <VideoSection></VideoSection>
      <ServicesFetureSection></ServicesFetureSection>
      <CounterSection></CounterSection>
      <PricingSection></PricingSection>
     
      <FAQSection></FAQSection>
      
      <ContactUs></ContactUs>
      
    </>
  );
};

export default Page;
